<template>
	<div>
		<ws-modal :title="dialog.title" v-model="dialog.show" @on-ok="ok">
			<div>
				<p v-for="item in dialog.contents" v-text="item"></p>
			</div>
		</ws-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialog: {
					show: false,
					title: '',
					contents: []
				}
			}
		},
		computed: {
			showTip() {
				let tipStatus = this.$store.getters.farmework_showTip;
				console.log('当前的提示状态为:' + tipStatus)
				return tipStatus;
			}
		},
		watch: {
			showTip(val, oldVal) {
				this.dialog.show = val;
			}
		},
		mounted() {
			let exts = this.$store.getters.auth_exts;
			this.dialog.show = exts.needTip;
			this.dialog.contents = exts.contents;
			this.dialog.title = '版本更新提示(' + exts.version + ')';
			
			//更新提示
			if(exts.preMessage) {
				this.$notify({
				  title: '系统更新提示',
				  duration: 0,
				  dangerouslyUseHTMLString: true,
				  message: '<strong>'+exts.preMessage+'</strong>'
				});
			}
		},
		methods: {
			ok() {
				this.$http.post('/ws/sys/upgrade/versions').then(response => {
					this.$store.dispatch('frameworkToggleTips' , {show: false});
					this.dialog.show = false;
				}); 
			},
			cancel() {
				
			}
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// tip.vue?36c47b69